import { RSAA } from "redux-api-middleware";
import { API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION } from "../util/constants";
import * as types from "./types/index";
import { handleUnauthorizedAccess } from "../util/utility";

// send tip from viewr side
export function sendTip(token, api_token, data) {

  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/send/tip?api_token=${api_token}`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
      types: [
        types.TIP_SEND_REQUEST,
        types.TIP_SEND_RECEIVE,
        {
          type: types.TIP_SEND_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetTip = () => ({
  type: types.TIP_SEND_RESET,
  payload: null,
});

// get tip data list
export function getTipDataList(token, api_token, broadcastId) {

  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/tip/broadcast/${broadcastId}?api_token=${api_token}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.TIP_DATA_REQUEST,
        types.TIP_DATA_RECEIVE,
        {
          type: types.TIP_DATA_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

// send tip for tip goal from viewr side
export function sendTipForTipGoal(token, api_token, data) {

  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/send/tip?api_token=${api_token}`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
      types: [
        types.TIP_GOAL_SEND_REQUEST,
        types.TIP_GOAL_SEND_RECEIVE,
        {
          type: types.TIP_GOAL_SEND_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetTipForTipGoal = () => ({
  type: types.TIP_GOAL_SEND_RESET,
  payload: null,
});

// get tip goal data list
export function getTipDataListForTipGoal(
  token,
  api_token,
  broadcastId,
  tip_goal_id
) {

  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/tip/broadcast/${broadcastId}?tip_goal_id=${tip_goal_id}&api_token=${api_token}`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: `Bearer ${token}`,
      },
      types: [
        types.TIP_GOAL_DATA_REQUEST,
        types.TIP_GOAL_DATA_RECEIVE,
        {
          type: types.TIP_GOAL_DATA_FAILURE,
          meta: (action, state, res) => {
            return handleUnauthorizedAccess(action, state, res);
          },
        },
      ],
    },
  };
}

export const resetTipDataListForTipGoal = () => ({
    type: types.TIP_GOAL_DATA_RESET,
    payload: null,
});
